import moment from "moment";

export default class Filters{
  
  formatDate(value, format = 0){
    let formattype = ['DD-MM-YYYY','DD [de] MMMM [de] YYYY'];
    moment.locale('es');
    return value ? moment(value).format(formattype[format]) : '-';
  }

  differentDate(begin,end){
    return moment(end).diff(begin, 'weeks');
  }

}